/** Paper field with a faint halftone grid. */
export function Background() {
  return (
    <div
      aria-hidden
      className="dither-lite pointer-events-none fixed inset-0 -z-10 opacity-[0.18]"
      style={{
        WebkitMaskImage: "radial-gradient(120% 100% at 50% 0%, #000 0%, transparent 70%)",
        maskImage: "radial-gradient(120% 100% at 50% 0%, #000 0%, transparent 70%)",
      }}
    />
  );
}
